import React, { useState, useEffect, useRef } from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import NotificationPanels from "./NotificationPanels";
import "../assets/css/candidate-tab-form.css";
import "../assets/css/inner-tabs.css";
import "../assets/css/form.css";
import ExclamationMark from "../assets/img/exclamation-mark-icon.svg";
import _ from "lodash";
import "../assets/css/custom-modal.css";
import EmploymentGapsInput from "./EmploymentGapsInput";
import { hasOnlySpaces } from "../Helper/common";

const EmploymentGaps = ({
  gapData,
  closeGapPopUp,
  handleGapReasonSubmit,
  gapReasonKey,
  gapName,
}) => {
  const [gap, setGap] = useState([]);
  const [errorData, setErrorData] = useState([]);

  useEffect(() => {
    setGap(gapData.responseArr[`${gapReasonKey}`]);
    const err = new Array(gapData.responseArr[`${gapReasonKey}`].length).fill(
      false
    );
    setErrorData(err);
  }, []);

  const handleReason = (val, key) => {
    const gapNew = _.cloneDeep(gap);
    gapNew[key].gap_reason = val;
    setGap(gapNew);
    const hasErr = hasOnlySpaces(val);
    const errNew = _.cloneDeep(gap);
    errNew[key] = hasErr;
    setErrorData(errNew);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let hasError = false;
    let errData = _.cloneDeep(errorData);
    for (var i in gap) {
      if (gap[i].gap_reason == "" || gap[i].gap_reason == null) {
        errData[i] = true;
        hasError = true;
      }
    }
    setErrorData(errData);
    if (!hasError) {
      handleGapReasonSubmit(gap);
    }
  };
  const len = gapData.responseArr[`${gapReasonKey}`].length;
  const gapKey = len == 1 ? "Gap" : "Gaps";

  return (
    <>
      <NotificationPanels />
      <Header />
      <Sidebar />

      <section
        className="main-section candidate-tab-form"
        style={{ paddingTop: "60px" }}
      ></section>

      <div className="dashboard custom-modal-dialog show" id="empGap">
        <div className="modal-wrapper">
          <div
            className="modal-content p-4 no-scroll"
            style={{ overflow: "unset", maxHeight: "unset" }}
          >
            <img src={ExclamationMark} alt="" width="39" />
            <h4 className="fnt-smi-bld auth-header mt-2">
              {len} {gapName} {gapKey} Found
            </h4>
            <span className="cstm-popup-close-btn" onClick={closeGapPopUp}>
              &times;
            </span>
            <p class="text-muted">Please give appropriate reason</p>

            <div
              style={{
                maxHeight: "330px",
                overflowY: "scroll",
                paddingLeft: "15px",
                paddingRight: "15px",
              }}
            >
              {gap.length > 0 &&
                gap.map((gapDataInp, key) => {
                  return (
                    <EmploymentGapsInput
                      data={gapDataInp}
                      index={key}
                      handleReason={handleReason}
                      hasError={errorData[key]}
                      gapName={gapName}
                    />
                  );
                })}
            </div>
            <div class="row">
              <div class="col-12">
                <button
                  className="btn btn-primary btn-lg btn-block"
                  onClick={(e) => handleSubmit(e)}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default EmploymentGaps;
